var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoLoginBackground(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 733.337,
    height: 415.294,
    viewBox: "0 0 733.337 415.294",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{clip-path:url(#a);}.c{fill:#1d4851;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 733.337,
    height: 415.294
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1464.21,595.923,1342.973,768.454v0q-2.206,3.151-4.624,6.145A114.562,114.562,0,0,1,1173.333,788.3c-7.258-6.446-13.929-13.647-20.786-20.5q-9.32-9.325-18.644-18.648-9.321,9.326-18.641,18.648c-6.856,6.856-13.528,14.058-20.786,20.5A114.5,114.5,0,0,1,929.463,774.6q-2.412-3-4.627-6.145L803.6,595.923A114.475,114.475,0,0,1,978.035,448.937l37.474,37.471q13.591-13.6,27.178-27.2,5.022-5.037,10.057-10.07a114.551,114.551,0,0,1,155.711-6.154c4.508,3.875,8.637,8.18,12.835,12.384,10.1,10.111,30.771,30.809,31.009,31.044l37.474-37.467A114.476,114.476,0,0,1,1464.21,595.923",
    transform: "translate(-767.238 -403.751)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLoginBackground);
export default __webpack_public_path__ + "static/media/logoLoginBackground.84e5419d94cd7bd036d0ec8d0faca9e9.svg";
export { ForwardRef as ReactComponent };